import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Slide } from '@mui/material';
export const Transition = forwardRef(function Transition(props, ref) {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
